<template>
  <div>
    <v-container>
      <v-alert
          v-if="error_alert"
          border="left"
          colored-border
          type="error"
          elevation="1"
      >
        An error has occured , we can't retrieve you vocab, please refresh the
        page .
      </v-alert>
    </v-container>
    <!-- snackbars for correct and false answer when training -->
    <v-snackbar v-model="correct_answer_snackbar" :timeout="snackbar_timeout">
      Well done , keep going.
    </v-snackbar>
    <v-snackbar v-model="false_answer_snackbar" :timeout="snackbar_timeout">
      Wrong match ,try Again.
    </v-snackbar>
    <!-- ----------------------------------------------------------- -->
    <div v-if="loading" class="hv_center">
      <v-progress-circular
          size="50"
          width="4"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>

    <div class="pa-8" v-else-if="!error_alert">
      <v-tabs vertical slider-color="primary">
        <v-tab href="#vocab-tab"> Vocab</v-tab>
        <v-tab v-on:click="setUpTraining" href="#train-tab"> Train</v-tab>
        <!--  -----------------Vocab tab--------------------------- -->
        <v-tab-item
            style="height: 79vh; max-height: 79vh; overflow-x: hidden"
            class="px-16"
            value="vocab-tab"
        >
          <v-tabs centered slider-color="primary">
            <v-tab href="#words-tab"> Words</v-tab>
            <v-tab href="#phrases-tab"> Phrases</v-tab>
            <!--  -----------------Words tab--------------------------- -->
            <!--            this just for setting a reference for scroll loading-->
            <span ref="scroll_loading_reference" />
            <v-tab-item value="words-tab">
              <v-card elevation="1" class="ma-4">
                <v-progress-linear
                    v-show="loading_morewords"
                    color="primary"
                    height="5"
                    indeterminate
                ></v-progress-linear>

                <div
                    style="max-height: 600px; heigth: 600px; overflow-x: hidden"
                    v-on:scroll="wordsOnScroll"
                >
                  <v-row class="ma-2" ref="words_vrow">
                    <v-col
                        v-for="word_data in words"
                        v-bind:key="word_data.word"
                    >
                      <v-btn depressed v-on:click="explainWord(word_data)"
                      >{{ word_data.word }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-card>
              <v-card
                  elevation="1"
                  height="450"
                  color="rgba(71,161,138,0.06)"
                  style="overflow-x: hidden"
                  class="ma-4"
                  v-if="explained_word"
              >
                <div class="text-center text-h3 arial_font">
                  <v-icon
                      size="50"
                      color="black"
                      :left="true"
                      v-on:click="
                      pronounce(
                        explained_word.source_language,
                         explained_word.word.split(/\(.*\)/)[1].trim()
                      )
                    "
                  >mdi-volume-high
                  </v-icon>
                  {{ explained_word.word }}
                </div>

                <div class="mx-8">
                  <h2
                      class="text-h4 arial_font text_darkgreen"
                      v-for="(trans, key) in explained_word.translations"
                      v-bind:key="key"
                  >
                    <v-icon size="30" color="black" :left="true" v-on:click="
                      pronounce(
                        key,
                         trans.translatedText
                      )
                    "
                    >mdi-volume-high
                    </v-icon
                    >
                    {{ key }} :
                    {{ trans.translatedText }}
                  </h2>
                  <v-divider class="my-4" inset></v-divider>
                  <ul>
                    <li
                        v-for="(def, i) in explained_word.dictionary"
                        v-bind:key="i"
                    >
                      <span class="text-h6">{{ def.partOfSpeech }}</span> :
                      {{ def.definition }}
                    </li>
                  </ul>
                </div>
              </v-card>
            </v-tab-item>
            <!--  -----------------Phrases tab--------------------------- -->
            <v-tab-item value="phrases-tab">
              <v-card elevation="1" style="overflow-x: hidden" class="ma-4">
                <v-progress-linear
                    v-show="loading_morephrases"
                    color="primary"
                    height="5"
                    indeterminate
                ></v-progress-linear>
                <div
                    v-scroll.self="phrasesOnScroll"
                    style="max-height: 600px; heigth: 600px; overflow-x: hidden"
                >
                  <v-row class="ma-2" ref="phrases_vrow">
                    <v-col v-for="(phrase_data, i) in phrases" v-bind:key="i">
                      <v-btn depressed v-on:click="explainPhrase(phrase_data)">
                        {{ phrase_data.phrase }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-card>
              <v-card
                  elevation="1"
                  height="450"
                  class="ma-4"
                  color="rgba(71,161,138,0.06)"
                  style="overflow-x: hidden"
                  v-if="explained_phrase"
              >
                <h1 class="text-center text-h5 arial_font text_darkgreen">
                  <v-icon
                      size="50"
                      color="black"
                      left="4"
                      v-on:click="
                      pronounce(
                        explained_phrase.source_language,
                        explained_phrase.phrase
                      )
                    "
                  >mdi-volume-high
                  </v-icon>
                  ({{ explained_phrase.source_language }})
                  {{ explained_phrase.phrase }}
                </h1>
                <div class="ma-8">
                  <h2
                      class="text-h6 arial_font"
                      v-for="(trans, key) in explained_phrase.translations"
                      v-bind:key="key"
                  >
                    <v-icon size="30" color="black" left="4" v-on:click="
                      pronounce(
                        key,
                        trans.translatedText
                      )
                    "
                    >mdi-volume-high
                    </v-icon
                    >
                    {{ key }} :
                    {{ trans.translatedText }}
                  </h2>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-tab-item>
        <!--  -----------------Train tab--------------------------- -->
        <v-tab-item value="train-tab" class="px-16">
          <!-- --------------------code for training -------------------- -->
          <v-card elevation="1" class="ma-4" max-height="600">
            <v-container>
              <v-card-title>Training ground</v-card-title>
              <v-card-subtitle
              >choose a language and how many words to revise
                :
              </v-card-subtitle
              >
              <v-select
                  :items="source_languages"
                  v-model="target_learning_lang"
                  label="languages"
                  outlined
              ></v-select>
              <v-slider
                  v-model="train_words_nbr"
                  hint=""
                  :max="max_words_nbr"
                  min="4"
                  thumb-label="always"
              >
              </v-slider>
              <v-btn v-on:click="startTraining">Start</v-btn>
            </v-container>
          </v-card>
          <v-card
              v-if="training"
              elevation="1"
              max-height="700"
              style="overflow-x: hidden"
              class="ma-4 pa-2"
          >
            <v-row>
              <v-col
                  v-for="word_obj in selected_train_words"
                  v-bind:key="word_obj.word"
              >
                <v-btn
                    depressed
                    v-on:click="match_word(word_obj)"
                    :disabled="word_obj.correct_pair"
                    :color="`${word_obj.selected ? 'secondary' : ''}`"
                >{{ word_obj.word }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
      </v-tabs>
      <v-dialog v-model="training_score_dialog" max-width="600">
        <v-card elevation="1">
          <v-card-title class="text-h5"> Training Score</v-card-title>

          <app-chart
              v-if="training_score_dialog"
              :data="chart_data"
          ></app-chart>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text v-on:click="saveStats">
              Save
            </v-btn
            >

            <v-btn
                color="green darken-1"
                text
                @click="training_score_dialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import { axios } from "../main";
import BarChart from "../components/BarChart";
import { debounce } from "lodash";

export default {
  name: "VocabLobby",
  data() {
    return {
      loading: true,
      error_alert: false,
      training: false,
      words: [
        {
          word: "ar/بعرق",
          data: {
            sourceLanguage: "ar",
            dictionary: "{\"word\":\"sweaty\",\"definitions\":[]}",
            translations: {
              hi: {
                translatedText: "पसीने से तर",
                detectedSourceLanguage: "ar"
              }
            }
          }
        },
        {
          word: "en/word",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"word\",\"definitions\":[{\"definition\":\"the divine word of God; the second person in the Trinity (incarnate in Jesus)\",\"partOfSpeech\":\"noun\"},{\"definition\":\"information about recent and important events\",\"partOfSpeech\":\"noun\"},{\"definition\":\"an exchange of views on some topic\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a secret word or phrase known only to a restricted group\",\"partOfSpeech\":\"noun\"},{\"definition\":\"the sacred writings of the Christian religions\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a promise\",\"partOfSpeech\":\"noun\"},{\"definition\":\"put into words or an expression\",\"partOfSpeech\":\"verb\"},{\"definition\":\"a brief statement\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a string of bits stored in computer memory\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a unit of language that native speakers can identify\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a verbal command for action\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              ar: { translatedText: "كلمة", detectedSourceLanguage: "en" },
              fr: { translatedText: "mot", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "ar/يشتغل",
          data: {
            sourceLanguage: "ar",
            dictionary:
                "{\"word\":\"works\",\"definitions\":[{\"definition\":\"the internal mechanism of a device\",\"partOfSpeech\":\"noun\"},{\"definition\":\"buildings for carrying on industrial labor\",\"partOfSpeech\":\"noun\"},{\"definition\":\"performance of moral or religious acts\",\"partOfSpeech\":\"noun\"},{\"definition\":\"everything available; usually preceded by `the'\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              hi: {
                translatedText: "काम करता है",
                detectedSourceLanguage: "ar"
              }
            }
          }
        },
        {
          word: "en/manager",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"manager\",\"definitions\":[{\"definition\":\"(sports) someone in charge of training an athlete or a team\",\"partOfSpeech\":\"noun\"},{\"definition\":\"someone who controls resources and expenditures\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              fr: { translatedText: "directeur", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/profitability",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"profitability\",\"definitions\":[{\"definition\":\"the quality of affording gain or benefit or profit\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              hi: { translatedText: "लाभप्रदता", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/folks",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"folks\",\"definitions\":[{\"definition\":\"people in general (often used in the plural)\",\"partOfSpeech\":\"noun\"},{\"definition\":\"your parents\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              fr: { translatedText: "gens", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/quickly",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"quickly\",\"definitions\":[{\"definition\":\"without taking pains\",\"partOfSpeech\":\"adverb\"},{\"definition\":\"with little or no delay\",\"partOfSpeech\":\"adverb\"},{\"definition\":\"with speed\",\"partOfSpeech\":\"adverb\"}]}",
            translations: {
              hi: { translatedText: "जल्दी से", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/free",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"free\",\"definitions\":[{\"definition\":\"not taken up by scheduled activities\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"part with a possession or right\",\"partOfSpeech\":\"verb\"},{\"definition\":\"not fixed in position\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"relieve from\",\"partOfSpeech\":\"verb\"},{\"definition\":\"free or remove obstruction from\",\"partOfSpeech\":\"verb\"},{\"definition\":\"remove or force out from a position\",\"partOfSpeech\":\"verb\"},{\"definition\":\"grant freedom to; free from confinement\",\"partOfSpeech\":\"verb\"},{\"definition\":\"make (assets) available\",\"partOfSpeech\":\"verb\"},{\"definition\":\"release (gas or energy) as a result of a chemical reaction or physical decomposition\",\"partOfSpeech\":\"verb\"},{\"definition\":\"free from obligations or duties\",\"partOfSpeech\":\"verb\"},{\"definition\":\"make (information) available for publication\",\"partOfSpeech\":\"verb\"},{\"definition\":\"completely wanting or lacking\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"people who are free\",\"partOfSpeech\":\"noun\"},{\"definition\":\"not literal\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"without restraint\",\"partOfSpeech\":\"adverb\"},{\"definition\":\"costing nothing\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"grant relief or an exemption from a rule or requirement to\",\"partOfSpeech\":\"verb\"},{\"definition\":\"let off the hook\",\"partOfSpeech\":\"verb\"},{\"definition\":\"not held in servitude\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"not limited or hampered; not under compulsion or restraint\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"not occupied or in use\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"unconstrained or not chemically bound in a molecule or not fixed and capable of relatively unrestricted motion\",\"partOfSpeech\":\"adjective\"}]}",
            translations: {
              fr: { translatedText: "gratuit", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/converting",
          data: {
            sourceLanguage: "en",
            dictionary: null,
            translations: {
              hi: { translatedText: "परिवर्तित", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/download",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"download\",\"definitions\":[{\"definition\":\"transfer a file or program from a central computer to a smaller computer or to a computer at a remote location\",\"partOfSpeech\":\"verb\"}]}",
            translations: {
              fr: {
                translatedText: "Télécharger",
                detectedSourceLanguage: "en"
              }
            }
          }
        },
        {
          word: "en/stylesheet",
          data: {
            sourceLanguage: "en",
            dictionary: null,
            translations: {
              fr: {
                translatedText: "feuille de style",
                detectedSourceLanguage: "en"
              }
            }
          }
        },
        {
          word: "en/holiday",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"holiday\",\"definitions\":[{\"definition\":\"leisure time away from work devoted to rest or pleasure\",\"partOfSpeech\":\"noun\"},{\"definition\":\"spend or take a vacation\",\"partOfSpeech\":\"verb\"},{\"definition\":\"a day on which work is suspended by law or custom\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              hi: {
                translatedText: "छुट्टी का दिन",
                detectedSourceLanguage: "en"
              }
            }
          }
        },
        {
          word: "en/before",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"before\",\"definitions\":[{\"definition\":\"earlier in time; previously\",\"partOfSpeech\":\"adverb\"},{\"definition\":\"at or in the front\",\"partOfSpeech\":\"adverb\"}]}",
            translations: {
              fr: { translatedText: "avant", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/helps",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"help\",\"definitions\":[{\"definition\":\"a person who contributes to the fulfillment of a need or furtherance of an effort or purpose\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a means of serving\",\"partOfSpeech\":\"noun\"},{\"definition\":\"improve the condition of\",\"partOfSpeech\":\"verb\"},{\"definition\":\"give help or assistance; be of service\",\"partOfSpeech\":\"verb\"},{\"definition\":\"a person or thing that is a resource that helps make something easier or possible to do\",\"partOfSpeech\":\"noun\"},{\"definition\":\"the activity of contributing to the fulfillment of a need or furtherance of an effort or purpose\",\"partOfSpeech\":\"noun\"},{\"definition\":\"abstain from doing; always used with a negative\",\"partOfSpeech\":\"verb\"},{\"definition\":\"be of use\",\"partOfSpeech\":\"verb\"},{\"definition\":\"help to some food; help with food or drink\",\"partOfSpeech\":\"verb\"},{\"definition\":\"take or use\",\"partOfSpeech\":\"verb\"},{\"definition\":\"contribute to the furtherance of\",\"partOfSpeech\":\"verb\"},{\"definition\":\"improve; change for the better\",\"partOfSpeech\":\"verb\"}]}",
            translations: {
              hi: {
                translatedText: "मदद करता है",
                detectedSourceLanguage: "en"
              }
            }
          }
        },
        {
          word: "en/many",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"many\",\"definitions\":[{\"definition\":\"a quantifier that can be used with count nouns and is often preceded by `as' or `too' or `so' or `that'; amounting to a large but indefinite number\",\"partOfSpeech\":\"adjective\"}]}",
            translations: {
              fr: { translatedText: "Beaucoup", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/visitors",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"visitor\",\"definitions\":[{\"definition\":\"someone who visits\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              hi: { translatedText: "आगंतुकों", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/function",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"function\",\"definitions\":[{\"definition\":\"the actions and activities assigned to or required or expected of a person or group\",\"partOfSpeech\":\"noun\"},{\"definition\":\"perform as expected when applied\",\"partOfSpeech\":\"verb\"},{\"definition\":\"(mathematics) a mathematical relation such that each element of a given set (the domain of the function) is associated with an element of another set (the range of the function)\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a vaguely specified social event\",\"partOfSpeech\":\"noun\"},{\"definition\":\"serve a purpose, role, or function\",\"partOfSpeech\":\"verb\"},{\"definition\":\"what something is used for\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a set sequence of steps, part of larger computer program\",\"partOfSpeech\":\"noun\"},{\"definition\":\"perform duties attached to a particular office or place or function\",\"partOfSpeech\":\"verb\"},{\"definition\":\"a formal or official social gathering or ceremony\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a relation such that one thing is dependent on another\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              fr: {
                translatedText: "une fonction",
                detectedSourceLanguage: "en"
              }
            }
          }
        },
        {
          word: "en/focuses",
          data: {
            sourceLanguage: "en",
            dictionary: "{\"word\":\"focuses\",\"definitions\":[]}",
            translations: {
              hi: { translatedText: "केंद्रित", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/components",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"component\",\"definitions\":[{\"definition\":\"an artifact that is one of the individual parts of which a composite entity is made up; especially a part that can be separated from or attached to a system\",\"partOfSpeech\":\"noun\"},{\"definition\":\"an abstract part of something\",\"partOfSpeech\":\"noun\"},{\"definition\":\"something determined in relation to something that includes it\",\"partOfSpeech\":\"noun\"}]}",
            translations: {}
          }
        },
        {
          word: "en/whether",
          data: {
            sourceLanguage: "en",
            dictionary: "{\"word\":\"whether\",\"definitions\":[]}",
            translations: {
              hi: { translatedText: "या", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/require",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"require\",\"definitions\":[{\"definition\":\"have need of\",\"partOfSpeech\":\"verb\"},{\"definition\":\"consider obligatory; request and expect\",\"partOfSpeech\":\"verb\"},{\"definition\":\"require as useful, just, or proper\",\"partOfSpeech\":\"verb\"},{\"definition\":\"make someone do something\",\"partOfSpeech\":\"verb\"}]}",
            translations: {
              fr: { translatedText: "exiger", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/spanish",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"spanish\",\"definitions\":[{\"definition\":\"the people of Spain\",\"partOfSpeech\":\"noun\"},{\"definition\":\"the Romance language spoken in most of Spain and the countries colonized by Spain\",\"partOfSpeech\":\"noun\"},{\"definition\":\"of or relating to or characteristic of Spain or the people of Spain\",\"partOfSpeech\":null}]}",
            translations: {
              hi: { translatedText: "स्पेनिश", detectedSourceLanguage: "en" },
              fr: { translatedText: "Espagnol", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/javascript",
          data: {
            sourceLanguage: "en",
            dictionary: null,
            translations: {
              fr: {
                translatedText: "Javascript",
                detectedSourceLanguage: "en"
              }
            }
          }
        },
        {
          word: "en/pictures",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"picture\",\"definitions\":[{\"definition\":\"graphic art consisting of an artistic composition made by applying paints to a surface\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a visual representation (of an object or scene or person or abstraction) produced on a surface\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a situation treated as an observable object\",\"partOfSpeech\":\"noun\"},{\"definition\":\"show in, or as in, a picture\",\"partOfSpeech\":\"verb\"},{\"definition\":\"illustrations used to decorate or explain a text\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a form of entertainment that enacts a story by sound and a sequence of images giving the illusion of continuous movement\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a graphic or vivid verbal description\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a clear and telling mental image\",\"partOfSpeech\":\"noun\"},{\"definition\":\"imagine; conceive of; see in one's mind\",\"partOfSpeech\":\"verb\"},{\"definition\":\"the visible part of a television transmission\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a representation of a person or scene in the form of a print or transparent slide or in digital format\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a typical example of some state or quality\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              hi: { translatedText: "चित्रों", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/near",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"near\",\"definitions\":[{\"definition\":\"with or in a close or intimate relationship\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"not far distant in time or space or degree or circumstances\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"near in time or place or relationship\",\"partOfSpeech\":\"adverb\"},{\"definition\":\"move towards\",\"partOfSpeech\":\"verb\"},{\"definition\":\"(of actions or states) slightly short of or not quite accomplished; all but\",\"partOfSpeech\":\"adverb\"},{\"definition\":\"being on the left side\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"very close in resemblance\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"giving or spending with reluctance\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"closely resembling the genuine article\",\"partOfSpeech\":\"adjective\"}]}",
            translations: {
              fr: { translatedText: "près", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/products",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"product\",\"definitions\":[{\"definition\":\"the set of elements common to two or more sets\",\"partOfSpeech\":\"noun\"},{\"definition\":\"an artifact that has been created by someone or some process\",\"partOfSpeech\":\"noun\"},{\"definition\":\"commodities offered for sale\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a quantity obtained by multiplication\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a chemical substance formed as a result of a chemical reaction\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a consequence of someone's efforts or of a particular set of circumstances\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              hi: { translatedText: "उत्पादों", detectedSourceLanguage: "en" },
              fr: {
                translatedText: "des produits",
                detectedSourceLanguage: "en"
              }
            }
          }
        },
        {
          word: "en/plugins",
          data: {
            sourceLanguage: "en",
            dictionary: null,
            translations: {
              fr: { translatedText: "plugins", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "fr/tromper",
          data: {
            sourceLanguage: "fr",
            dictionary:
                "{\"word\":\"deceive\",\"definitions\":[{\"definition\":\"be false to; be dishonest with\",\"partOfSpeech\":\"verb\"},{\"definition\":\"cause someone to believe an untruth\",\"partOfSpeech\":\"verb\"}]}",
            translations: {
              hi: { translatedText: "धोखा", detectedSourceLanguage: "fr" }
            }
          }
        },
        {
          word: "en/come",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"come\",\"definitions\":[{\"definition\":\"come from; be connected by a relationship of blood, for example\",\"partOfSpeech\":\"verb\"},{\"definition\":\"add up in number or quantity\",\"partOfSpeech\":\"verb\"},{\"definition\":\"come to one's mind; suggest itself\",\"partOfSpeech\":\"verb\"},{\"definition\":\"the thick white fluid containing spermatozoa that is ejaculated by the male genital tract\",\"partOfSpeech\":\"noun\"},{\"definition\":\"come forth\",\"partOfSpeech\":\"verb\"},{\"definition\":\"move toward, travel toward something or somebody or approach something or somebody\",\"partOfSpeech\":\"verb\"},{\"definition\":\"be a native of\",\"partOfSpeech\":\"verb\"},{\"definition\":\"develop into\",\"partOfSpeech\":\"verb\"},{\"definition\":\"proceed or get along\",\"partOfSpeech\":\"verb\"},{\"definition\":\"come under, be classified or included\",\"partOfSpeech\":\"verb\"},{\"definition\":\"reach a destination; arrive by movement or progress\",\"partOfSpeech\":\"verb\"},{\"definition\":\"be received\",\"partOfSpeech\":\"verb\"},{\"definition\":\"to be the product or result\",\"partOfSpeech\":\"verb\"},{\"definition\":\"be found or available\",\"partOfSpeech\":\"verb\"},{\"definition\":\"come to pass; arrive, as in due course\",\"partOfSpeech\":\"verb\"},{\"definition\":\"cover a certain distance\",\"partOfSpeech\":\"verb\"},{\"definition\":\"exist or occur in a certain point in a series\",\"partOfSpeech\":\"verb\"},{\"definition\":\"experience orgasm\",\"partOfSpeech\":\"verb\"},{\"definition\":\"extend or reach\",\"partOfSpeech\":\"verb\"},{\"definition\":\"happen as a result\",\"partOfSpeech\":\"verb\"},{\"definition\":\"have a certain priority\",\"partOfSpeech\":\"verb\"},{\"definition\":\"reach or enter a state, relation, condition, use, or position\",\"partOfSpeech\":\"verb\"}]}",
            translations: {
              fr: { translatedText: "viens", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "fr/trompes",
          data: {
            sourceLanguage: "fr",
            dictionary:
                "{\"word\":\"horn\",\"definitions\":[{\"definition\":\"a brass musical instrument consisting of a conical tube that is coiled into a spiral and played by means of valves\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a high pommel of a Western saddle (usually metal covered with leather)\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a brass musical instrument with a brilliant tone; has a narrow tube and a flared bell and is played by means of valves\",\"partOfSpeech\":\"noun\"},{\"definition\":\"stab or pierce with a horn or tusk\",\"partOfSpeech\":\"verb\"},{\"definition\":\"a device on an automobile for making a warning noise\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a device having the shape of a horn\",\"partOfSpeech\":\"noun\"},{\"definition\":\"an alarm device that makes a loud warning sound\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a noise made by the driver of an automobile to give warning\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a noisemaker (as at parties or games) that makes a loud noise when you blow through it\",\"partOfSpeech\":\"noun\"},{\"definition\":\"any hard protuberance from the head of an organism that is similar to or suggestive of a horn\",\"partOfSpeech\":\"noun\"},{\"definition\":\"one of the bony outgrowths on the heads of certain ungulates\",\"partOfSpeech\":\"noun\"},{\"definition\":\"the material (mostly keratin) that covers the horns of ungulates and forms hooves and claws and nails\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              hi: { translatedText: "सींग का", detectedSourceLanguage: "fr" }
            }
          }
        },
        {
          word: "en/example",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"example\",\"definitions\":[{\"definition\":\"a representative form or pattern\",\"partOfSpeech\":\"noun\"},{\"definition\":\"something to be imitated\",\"partOfSpeech\":\"noun\"},{\"definition\":\"an occurrence of something\",\"partOfSpeech\":\"noun\"},{\"definition\":\"an item of information that is typical of a class or group\",\"partOfSpeech\":\"noun\"},{\"definition\":\"punishment intended as a warning to others\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a task performed or problem solved in order to develop skill or understanding\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              fr: { translatedText: "exemple", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/group...",
          data: {
            sourceLanguage: "en",
            dictionary: null,
            translations: {
              hi: { translatedText: "समूह ...", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/unsure",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"unsure\",\"definitions\":[{\"definition\":\"lacking self-confidence\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"lacking or indicating lack of confidence or assurance\",\"partOfSpeech\":\"adjective\"}]}",
            translations: {
              fr: { translatedText: "incertain", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/afternoon",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"afternoon\",\"definitions\":[{\"definition\":\"a conventional expression of greeting or farewell\",\"partOfSpeech\":\"noun\"},{\"definition\":\"the part of the day between noon and evening\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              hi: { translatedText: "दोपहर", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/general",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"general\",\"definitions\":[{\"definition\":\"a general officer of the highest rank\",\"partOfSpeech\":\"noun\"},{\"definition\":\"the head of a religious order or congregation\",\"partOfSpeech\":\"noun\"},{\"definition\":\"of worldwide scope or applicability\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"a fact about the whole (as opposed to particular)\",\"partOfSpeech\":\"noun\"},{\"definition\":\"affecting the entire body\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"applying to all or most members of a category or group\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"command as a general\",\"partOfSpeech\":\"verb\"},{\"definition\":\"not specialized or limited to one class of things\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"prevailing among and common to the general public\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"somewhat indefinite\",\"partOfSpeech\":\"adjective\"}]}",
            translations: {
              fr: { translatedText: "général", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/good",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"good\",\"definitions\":[{\"definition\":\"that which is pleasing or valuable or useful\",\"partOfSpeech\":\"noun\"},{\"definition\":\"articles of commerce\",\"partOfSpeech\":\"noun\"},{\"definition\":\"with or in a close or intimate relationship\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"moral excellence or admirableness\",\"partOfSpeech\":\"noun\"},{\"definition\":\"exerting force or influence\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"promoting or enhancing well-being\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"(often used as a combining form) in a good or proper or satisfactory manner or to a high standard (`good' is a nonstandard dialectal variant for `well')\",\"partOfSpeech\":\"adverb\"},{\"definition\":\"tending to promote physical well-being; beneficial to health\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"appealing to the mind\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"of moral excellence\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"not left to spoil\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"in excellent physical condition\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"not forged\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"having the normally expected amount\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"completely and absolutely (`good' is sometimes used informally for `thoroughly')\",\"partOfSpeech\":\"adverb\"},{\"definition\":\"deserving of esteem and respect\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"resulting favorably\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"having or showing knowledge and skill and aptitude\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"financially safe\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"most suitable or right for a particular purpose\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"agreeable or pleasing\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"benefit\",\"partOfSpeech\":\"noun\"},{\"definition\":\"capable of pleasing\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"generally admired\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"having desirable or positive qualities especially those suitable for a thing specified\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"morally admirable\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"thorough\",\"partOfSpeech\":\"adjective\"}]}",
            translations: {
              hi: { translatedText: "अच्छा", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/curious",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"curious\",\"definitions\":[{\"definition\":\"beyond or deviating from the usual or expected\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"eager to investigate and learn or learn more (sometimes about others' concerns)\",\"partOfSpeech\":\"adjective\"}]}",
            translations: {
              fr: { translatedText: "Curieuse", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/bootstrap",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"bootstrap\",\"definitions\":[{\"definition\":\"a strap that is looped and sewn to the top of a boot for pulling it on\",\"partOfSpeech\":\"noun\"},{\"definition\":\"help oneself, often through improvised means\",\"partOfSpeech\":\"verb\"}]}",
            translations: {
              fr: { translatedText: "Amorcer", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/development",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"development\",\"definitions\":[{\"definition\":\"processing a photosensitive material in order to make an image visible\",\"partOfSpeech\":\"noun\"},{\"definition\":\"the act of making some area of land or water more profitable or productive or useful\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a process in which something passes by degrees to a different stage (especially a more advanced or mature stage)\",\"partOfSpeech\":\"noun\"},{\"definition\":\"(biology) the process of an individual organism growing organically; a purely biological unfolding of events involved in an organism changing gradually from a simple to a more complex level\",\"partOfSpeech\":\"noun\"},{\"definition\":\"act of improving by expanding or enlarging or refining\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a district that has been developed to serve some purpose\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a recent event that has some relevance for the present situation\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a state in which things are improving; the result of developing (as in the early part of a game of chess)\",\"partOfSpeech\":\"noun\"},{\"definition\":\"(music) the section of a composition or movement (especially in sonata form) where the major musical themes are developed and elaborated\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              fr: {
                translatedText: "développement",
                detectedSourceLanguage: "en"
              }
            }
          }
        },
        {
          word: "en/popovers",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"popover\",\"definitions\":[{\"definition\":\"light hollow muffin made of a puff batter (individual Yorkshire pudding) baked in a deep muffin cup\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              fr: { translatedText: "popovers", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/developers",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"developer\",\"definitions\":[{\"definition\":\"photographic equipment consisting of a chemical solution for developing film\",\"partOfSpeech\":\"noun\"},{\"definition\":\"someone who develops real estate (especially someone who prepares a site for residential or commercial use)\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              fr: {
                translatedText: "les développeurs",
                detectedSourceLanguage: "en"
              },
              ar: { translatedText: "المطورين", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/element",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"element\",\"definitions\":[{\"definition\":\"an artifact that is one of the individual parts of which a composite entity is made up; especially a part that can be separated from or attached to a system\",\"partOfSpeech\":\"noun\"},{\"definition\":\"any of the more than 100 known substances (of which 92 occur naturally) that cannot be separated into simpler substances and that singly or in combination constitute all matter\",\"partOfSpeech\":\"noun\"},{\"definition\":\"an abstract part of something\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a straight line that generates a cylinder or cone\",\"partOfSpeech\":\"noun\"},{\"definition\":\"one of four substances thought in ancient and medieval cosmology to constitute the physical universe\",\"partOfSpeech\":\"noun\"},{\"definition\":\"the most favorable environment for a plant or animal\",\"partOfSpeech\":\"noun\"},{\"definition\":\"the situation in which you are happiest and most effective\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              fr: { translatedText: "élément", detectedSourceLanguage: "en" },
              ar: { translatedText: "جزء", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/book",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"book\",\"definitions\":[{\"definition\":\"physical objects consisting of a number of pages bound together\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a record in which commercial accounts are recorded\",\"partOfSpeech\":\"noun\"},{\"definition\":\"the sacred writings of Islam revealed by God to the prophet Muhammad during his life at Mecca and Medina\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a compilation of the known facts regarding something or someone\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a written version of a play or other dramatic composition; used in preparing for a performance\",\"partOfSpeech\":\"noun\"},{\"definition\":\"the sacred writings of the Christian religions\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a collection of rules or prescribed standards on the basis of which decisions are made\",\"partOfSpeech\":\"noun\"},{\"definition\":\"arrange for and reserve (something for someone else) in advance\",\"partOfSpeech\":\"verb\"},{\"definition\":\"a collection of playing cards satisfying the rules of a card game\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a major division of a long written composition\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a number of sheets (ticket or stamps etc.) bound together on one edge\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a written work or composition that has been published (printed on pages bound together)\",\"partOfSpeech\":\"noun\"},{\"definition\":\"engage for a performance\",\"partOfSpeech\":\"verb\"},{\"definition\":\"record a charge in a police register\",\"partOfSpeech\":\"verb\"},{\"definition\":\"register in a hotel booker\",\"partOfSpeech\":\"verb\"}]}",
            translations: {
              fr: { translatedText: "livre", detectedSourceLanguage: "en" },
              ar: { translatedText: "كتاب", detectedSourceLanguage: "en" },
              hi: { translatedText: "पुस्तक", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/site",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"site\",\"definitions\":[{\"definition\":\"assign a location to\",\"partOfSpeech\":\"verb\"},{\"definition\":\"physical position in relation to the surroundings\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a computer connected to the internet that maintains a series of web pages on the World Wide Web\",\"partOfSpeech\":\"noun\"},{\"definition\":\"the piece of land on which something is located (or is to be located)\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              fr: { translatedText: "site", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/language",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"language\",\"definitions\":[{\"definition\":\"a systematic means of communicating by the use of sounds or conventional symbols\",\"partOfSpeech\":\"noun\"},{\"definition\":\"(language) communication by word of mouth\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a system of words used to name things in a particular discipline\",\"partOfSpeech\":\"noun\"},{\"definition\":\"the mental faculty or power of vocal communication\",\"partOfSpeech\":\"noun\"},{\"definition\":\"the cognitive processes involved in producing and understanding linguistic communication\",\"partOfSpeech\":\"noun\"},{\"definition\":\"the text of a popular song or musical-comedy number\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              fr: { translatedText: "Langue", detectedSourceLanguage: "en" },
              ar: { translatedText: "لغة", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/examples",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"example\",\"definitions\":[{\"definition\":\"a representative form or pattern\",\"partOfSpeech\":\"noun\"},{\"definition\":\"something to be imitated\",\"partOfSpeech\":\"noun\"},{\"definition\":\"an occurrence of something\",\"partOfSpeech\":\"noun\"},{\"definition\":\"an item of information that is typical of a class or group\",\"partOfSpeech\":\"noun\"},{\"definition\":\"punishment intended as a warning to others\",\"partOfSpeech\":\"noun\"},{\"definition\":\"a task performed or problem solved in order to develop skill or understanding\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              fr: { translatedText: "exemples", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/your",
          data: {
            sourceLanguage: "en",
            dictionary: "{\"word\":\"your\",\"definitions\":[]}",
            translations: {
              fr: { translatedText: "votre", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/speak",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"speak\",\"definitions\":[{\"definition\":\"exchange thoughts; talk with\",\"partOfSpeech\":\"verb\"},{\"definition\":\"use language\",\"partOfSpeech\":\"verb\"},{\"definition\":\"give a speech to\",\"partOfSpeech\":\"verb\"},{\"definition\":\"express in speech\",\"partOfSpeech\":\"verb\"},{\"definition\":\"make a characteristic or natural sound\",\"partOfSpeech\":\"verb\"}]}",
            translations: {
              fr: { translatedText: "parler", detectedSourceLanguage: "en" }
            }
          }
        },
        {
          word: "en/found",
          data: {
            sourceLanguage: "en",
            dictionary:
                "{\"word\":\"found\",\"definitions\":[{\"definition\":\"use as a basis for; found on\",\"partOfSpeech\":\"verb\"},{\"definition\":\"set up or lay the groundwork for\",\"partOfSpeech\":\"verb\"},{\"definition\":\"set up or found\",\"partOfSpeech\":\"verb\"},{\"definition\":\"come upon unexpectedly or after searching\",\"partOfSpeech\":\"adjective\"},{\"definition\":\"food and lodging provided in addition to money\",\"partOfSpeech\":\"noun\"}]}",
            translations: {
              fr: { translatedText: "a trouvé", detectedSourceLanguage: "en" }
            }
          }
        }
      ],
      explained_word: undefined,
      phrases: [
        {
          translations: {
            fr: {
              translatedText: "PROJETS PERSONNELS",
              detectedSourceLanguage: "en"
            }
          },
          sourceLanguage: "en",
          phrase: "PERSONAL PROJECTS"
        },
        {
          translations: {
            fr: { translatedText: "J'écris", detectedSourceLanguage: "en" }
          },
          sourceLanguage: "en",
          phrase: "I'm writing"
        },
        {
          translations: {
            fr: { translatedText: "J'écris", detectedSourceLanguage: "en" }
          },
          sourceLanguage: "en",
          phrase: "I'm writing"
        },
        {
          translations: {
            fr: { translatedText: "j'ai", detectedSourceLanguage: "en" }
          },
          sourceLanguage: "en",
          phrase: "I have"
        },
        {
          translations: {
            en: {
              translatedText:
                  "Certify that I have made the corrections requested by the jury of my end of studies thesis and in",
              detectedSourceLanguage: "fr"
            }
          },
          sourceLanguage: "fr",
          phrase:
              "Atteste avoir effectué les corrections demandées par le jury de mon mémoire de fin d'études et en"
        },
        {
          translations: {
            en: {
              translatedText:
                  "Calculus of real-valued functions of several real variables",
              detectedSourceLanguage: "en"
            }
          }
        },
        {
          translations: {
            ar: {
              translatedText: "ملاحظات هامة",
              detectedSourceLanguage: "en"
            }
          },
          sourceLanguage: "en",
          phrase: "Important Notes"
        },
        {
          translations: {
            ar: { translatedText: "بات النثر", detectedSourceLanguage: "en" }
          },
          sourceLanguage: "en",
          phrase: "Sparsity pat"
        },
        {
          translations: {
            ar: { translatedText: "تعافى الدعم", detectedSourceLanguage: "en" }
          },
          sourceLanguage: "en",
          phrase: "Recovered support"
        },
        {
          translations: {
            ar: {
              translatedText: "أساس له جميع الحقوق محفوظة",
              detectedSourceLanguage: "en"
            }
          },
          sourceLanguage: "en",
          phrase: "basis has all coeﬃcien"
        },
        {
          translations: {
            ar: {
              translatedText: "اقترحنا إطارًا جديدًا للتعلم الجماعي",
              detectedSourceLanguage: "en"
            }
          },
          sourceLanguage: "en",
          phrase: "We proposed a novel framework for learning grouping"
        }
      ],
      explained_phrase: undefined,
      // training data
      train_words_nbr: 5,
      words_by_source_lang: {},
      source_languages: [],
      word_couples: {},
      target_learning_lang: undefined,
      selected_train_words: [],
      word_pair: [],
      element_pair: [],
      nbrof_correct_matches: 0,
      nbrof_false_matches: 0,
      false_answer_snackbar: false,
      correct_answer_snackbar: false,
      snackbar_timeout: 1500,
      training_score_dialog: false,
      words_total: 0,
      initial_words_size: 0,
      words_current_page: 1,
      words_reload_size: 75,
      loading_morewords: false,
      phrases_total: 0,
      initial_phrases_size: 0,
      phrases_current_page: 1,
      phrases_reload_size: 75,
      loading_morephrases: false,
      load_morewords_debounced: debounce(this.load_morewords, 1000, {
        leading: true
      })
    };
  },
  computed: {
    max_words_nbr: {
      get() {
        return this.words ? Object.keys(this.words).length : 0;
      },
      set() {
      }
    },
    current_words_checkpoint: {
      get() {
        return Math.min(
            this.initial_words_size +
            this.words_reload_size * (this.words_current_page - 1),
            this.words_total
        );
      }
    },
    current_phrases_checkpoint: {
      get() {
        return Math.min(
            this.initial_phrases_size +
            this.phrases_reload_size * (this.phrases_current_page - 1),
            this.phrases_total
        );
      }
    },
    chart_data: {
      get() {
        return {
          labels: ["Correct Matches", "False Matches"],
          datasets: [
            {
              label: "Training Stats",
              backgroundColor: ["#00a99e20", "#f5565620"],
              borderColor: ["#00a99e", "#f55656"],
              data: [this.nbrof_correct_matches, this.nbrof_false_matches],
              borderWidth: 1
            }
          ]
        };
      },
      set() {
      }
    }
  },
  mounted() {
    this.load_morewords();
    this.load_morephrases();
  },
  methods: {
    wordsOnScroll() {
      let words_vrow = this.$refs.words_vrow;
      let scroll_loading_reference = this.$refs.scroll_loading_reference;
      if (words_vrow) {
        let margin_bottom = words_vrow.getBoundingClientRect().bottom;
        let ref = scroll_loading_reference.getBoundingClientRect().bottom;
        if (margin_bottom - ref < 700) {
          this.load_morewords_debounced();
        }
      }
    },

    async load_morewords() {
      if (this.loading_morewords) {
        return;
      }
      this.loading_morewords = true;
      try {
        if (!this.words_total) {
          this.loading = true;
          let more_words = await axios
              .get("/words", {
                params: {
                  from: this.current_words_checkpoint,
                  to: 150
                }
              })
              .then((res) => res.data);
          this.initial_words_size = more_words.words.length;
          this.words = more_words.words;
          this.words_total = more_words.total;

          return;
        }
      } catch (err) {
        console.log(err);
        this.error_alert = true;
      } finally {
        this.loading = false;
        this.loading_morewords = false;
      }

      try {
        if (this.words_total > this.current_words_checkpoint) {
          let from = this.current_words_checkpoint;
          this.words_current_page++;
          let more_words = await axios
              .get("/words", {
                params: {
                  from,
                  to: this.current_words_checkpoint
                }
              })
              .then((res) => res.data);

          for (let word of more_words.words) {
            this.words.push(word);
          }
        }
      } catch (err) {
        console.log("couldn't load more words ", err);
      } finally {
        this.loading = false;
        this.loading_morewords = false;
      }
    },

    explainWord(word_data) {
      let word = word_data.word;
      let word_defs = JSON.parse(word_data.data.dictionary);
      word_defs = word_defs ? word_defs.definitions : [];
      let word_trans = word_data.data.translations;
      let source_language = word_data.data.sourceLanguage;
      this.explained_word = {
        word: `(${word.replace("/", ") ")}`,
        dictionary: word_defs,
        translations: word_trans,
        source_language
      };
    },
    phrasesOnScroll() {
      let phrases_vrow = this.$refs.phrases_vrow;
      let scroll_loading_reference = this.$refs.scroll_loading_reference;
      if (phrases_vrow) {
        let margin_bottom = phrases_vrow.getBoundingClientRect().bottom;
        let ref = scroll_loading_reference.getBoundingClientRect().bottom;
        if (margin_bottom - ref < 700) {
          this.load_morephrases();
        }
      }
    },
    async load_morephrases() {
      if (this.loading_morephrases) return;
      this.loading_morephrases = true;
      if (!this.phrases_total) {
        try {
          let more_phrases = await axios
              .get("/phrases", {
                params: {
                  from: this.current_phrases_checkpoint,
                  to: 150
                }
              })
              .then((res) => res.data);
          this.initial_phrases_size = more_phrases.phrases.length;
          this.phrases = more_phrases.phrases.map((phrase) => {
            let phraseModified = { translations: {} };
            for (let key in phrase) {
              if (typeof phrase[key] == "string") {
                phraseModified.sourceLanguage = key;
                phraseModified.phrase = phrase[key];
              } else {
                phraseModified.translations[key] = phrase[key];
              }
            }
            return phraseModified;
          });
          this.phrases_total = more_phrases.total;
        } catch (err) {
          console.log(err);
          this.error_alert = true;
        } finally {
          this.loading = false;
          this.loading_morephrases = false;
        }
        return;
      }
      if (this.phrases_total > this.current_phrases_checkpoint) {
        try {
          let from = this.current_phrases_checkpoint;
          this.phrases_current_page++;
          let more_phrases = await axios
              .get("/phrases", {
                params: {
                  from,
                  to: this.current_phrases_checkpoint
                }
              })
              .then((res) => res.data);

          for (let phrase of more_phrases.phrases) {
            this.phrases.push(phrase);
          }
        } catch (err) {
          console.log("couldn't load more phrases ", err);
        } finally {
          this.loading = false;
          this.loading_morephrases = false;
        }
      }
    },
    explainPhrase(phrase_data) {
      this.explained_phrase = {
        phrase: phrase_data.phrase,
        translations: phrase_data.translations,
        source_language: phrase_data.sourceLanguage
      };
    },
    pronounce(target_lang, elem) {

      axios
          .get(`/pronounce/${target_lang}/${elem}`)
          .then((res) => {
            new Audio(`data:audio/ogg;base64,${res.data.pronounce}`).play();
          })
          .catch((err) => {
            console.log(err);
          });
    },
    async getWords() {
      this.loading = true;
      try {
        // let access_token = await this.$auth.getTokenSilently()
        let response = await axios.get("/words");
        if (response.status == 200) {
          this.words = response.data;
        }
      } catch (err) {
        console.log(err);
        this.error_alert = true;
      }
      try {
        let response = await axios.get("/phrases");
        if (response.status == 200) {
          this.phrases = response.data.phrases.map((phrase) => {
            let phraseModified = { translations: {} };
            for (let key in phrase) {
              if (typeof phrase[key] == "string") {
                phraseModified.sourceLanguage = key;
                phraseModified.phrase = phrase[key];
              } else {
                phraseModified.translations[key] = phrase[key];
              }
            }
            return phraseModified;
          });
        }
      } catch (err) {
        this.error_alert = true;
      }
      this.loading = false;
    },
    setUpTraining() {
      if (!this.training) {
        this.max_words_nbr = this.words.length;
        if (Object.keys(this.words_by_source_lang).length == 0) {
          for (let word_value of this.words) {
            let available_trans = Object.keys(word_value.data.translations);
            if (available_trans.length == 0) continue;
            let word_trans =
                word_value.data.translations[available_trans[0]].translatedText;
            let detected_source_lang = word_value.word.split("/")[0];

            if (this.source_languages.includes(detected_source_lang)) {
              this.words_by_source_lang[detected_source_lang].push(
                  word_value.word
              );
            } else {
              this.words_by_source_lang[detected_source_lang] = [
                word_value.word
              ];
              this.source_languages.push(detected_source_lang);
            }
            this.word_couples[
                word_value.word
                ] = `(${available_trans[0]}) ${word_trans}`;
          }

          this.target_learning_lang = this.source_languages[0];
        }

        this.training = true;
      }
    },
    resetTraining() {
      this.word_pair = [];

      this.nbrof_correct_matches = 0;
      this.nbrof_false_matches = 0;
      this.selected_train_words = [];
    },
    stopTraining() {
      this.training = false;
      this.word_pair = [];
      this.selected_train_words = [];

      this.nbrof_correct_matches = 0;
      this.nbrof_false_matches = 0;
    },
    startTraining() {
      this.training = true;
      this.resetTraining();
      this.shuffle(this.words_by_source_lang[this.target_learning_lang]);

      this.selected_train_words = this.words_by_source_lang[
          this.target_learning_lang
          ].slice(0, this.train_words_nbr);

      let selected_translations = [];

      for (let word of this.selected_train_words) {
        selected_translations.push(this.word_couples[word]);
      }

      this.selected_train_words.push(selected_translations);
      this.selected_train_words = this.selected_train_words
          .flat()
          .map((word) => {
            return { word, selected: false, correct_pair: false };
          });
      this.shuffle(this.selected_train_words);
    },
    match_word(word_obj) {
      if (this.word_pair.length == 1) {
        if (word_obj.selected) {
          word_obj.selected = false;
          this.word_pair.pop();
        } else {
          this.word_pair.push(word_obj);
          // clicked_word.classList.add('pair')
          word_obj.selected = true;
          let main_word = this.word_pair[0].word;
          let second_word = this.word_pair[1].word;

          if (this.word_couples[main_word]) {
            main_word = this.word_pair[0].word;
            second_word = this.word_pair[1].word;
          } else if (this.word_couples[second_word]) {
            main_word = this.word_pair[1].word;
            second_word = this.word_pair[0].word;
          } else {
            for (let element of this.word_pair) {
              element.selected = false;
            }

            this.word_pair = [];
            return null;
          }

          let transWord = this.word_couples[main_word];
          if (transWord === second_word) {
            this.correct_answer_snackbar = true;
            for (let element of this.word_pair) {
              element.selected = false;
              element.correct_pair = true;
            }
            this.word_pair = [];
            this.nbrof_correct_matches++;
            if (this.nbrof_correct_matches == this.train_words_nbr) {
              this.training_score_dialog = true;
              // this.showStats()
            }
          } else {
            this.false_answer_snackbar = true;
            this.nbrof_false_matches++;
            for (let element of this.word_pair) {
              element.selected = false;
            }

            this.word_pair = [];
          }
        }
      } else {
        this.word_pair.push(word_obj);
        word_obj.selected = true;
      }
    },
    shuffle(arr) {
      var m = arr.length,
          t,
          i;

      // While there remain elements to shuffle…
      while (m) {
        // Pick a remaining element…
        i = Math.floor(Math.random() * m--);

        // And swap it with the current element.
        t = arr[m];
        arr[m] = arr[i];
        arr[i] = t;
      }

      return arr;
    },
    saveStats() {
      let score =
          this.nbrof_correct_matches /
          (this.nbrof_false_matches == 0 ? 1 : this.nbrof_false_matches);

      axios.post("/saveStats", {
        date: Date.now(),
        learningLangauge: this.target_learning_lang,
        score,
        nbrOfCorrectMatches: this.nbrof_correct_matches,
        nbrOfFalseAttempts: this.nbrof_false_matches
      });

      this.stopTraining();
    }
  },
  components: {
    "app-chart": BarChart
  }
};
</script>
<style scoped>
.main {
  font-family: "Arial Rounded MT" !important;
}

.pair {
  background-color: #00a99eb6 !important;
}

.correct_pair {
  background-color: #00a99e !important;
  color: white !important;
}

.text_darkgreen {
  color: #0c5460;
}

.arial_font {
  font-family: "Arial Rounded MT" !important;
}

#wordInfos::-webkit-scrollbar {
  width: 6px;
  background-color: #00d69e10;
}

#phraseInfos::-webkit-scrollbar {
  width: 6px;
  background-color: #00d69e10;
}

::-webkit-scrollbar-thumb {
  background-color: #00a99e80;
}

::-webkit-scrollbar {
  width: 6px;
  background-color: #00d69e10;
}

</style>
